import {
	Directive,
	ElementRef,
	forwardRef,
	Host,
	HostListener
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ImageUploadComponent } from '@array-app/frontend/files';
import { ValueAccessor } from './value-accessor';

@Directive({
	standalone: true,
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: 'app-image-upload[formControlName]',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ImageUploadValueAccessorDirective),
			multi: true
		}
	]
})
export class ImageUploadValueAccessorDirective extends ValueAccessor<string> {
	constructor(
		@Host() protected override host: ImageUploadComponent,
		protected override readonly el: ElementRef
	) {
		super(host, el);
	}

	@HostListener('valueChange', ['$event'])
	_handleChangeEvent(value: string) {
		this.handleChangeEvent(this.el.nativeElement, value);
	}
}
